"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ListIcon = void 0;
var _icons = require("@ori-ui/icons");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const ListIcon = ()=>{
    const { getTestId } = (0, _testidGenerator.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.IconWrapper, {
        "data-testid": getTestId(_constants.LIST_ICON_WRAPPER),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_icons.ProductsFilled, {})
    });
};
exports.ListIcon = ListIcon;
